// 📄 services/estatusFacturaBotService.ts
// Única llamada HTTP de este feature desde el frontend: confirmar el
// código PRD de un envío armado por Nexus AI (ver GeminiChat.tsx). El
// código nunca se envía como mensaje de chat ni pasa por Gemini — este
// endpoint es independiente del trigger onebotGemini (ver
// functions/routes/estatusFacturaBot.js).
import { getAuth } from "firebase/auth";

export interface ConfirmarEnvioPrdResultado {
  ok: boolean;
  error?: "codigo_invalido" | "expirado" | "excedio_intentos" | "no_autorizado" | "solicitud_invalida" | string;
  intentosRestantes?: number;
  respuestaAriba?: string;
  resumen?: {
    proyecto: string;
    ambiente: string;
    systemId: string;
    idProveedor: string;
    referenciaFactura: string;
    estatusFactura: string;
    etiquetaEstatus: string;
    comentarios: string | null;
  };
}

export const confirmarEnvioEstatusFacturaPrd = async (
  pendingId: string,
  codigo: string
): Promise<ConfirmarEnvioPrdResultado> => {
  const user = getAuth().currentUser;
  if (!user) throw new Error("No se detectó una sesión activa. Por favor, reingresa al sistema.");
  const token = await user.getIdToken();

  const response = await fetch(`${process.env.REACT_APP_API_URL}/estatus-factura-bot/confirmar-prd`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ pendingId, codigo })
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Error ${response.status} al confirmar el envío.`);
  }
  return data;
};
